import {useState, useRef, useEffect} from 'react'

export default (deps: ReadonlyArray<any>): boolean => {
  const [flash, setFlash] = useState(false)
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (!isFirstRender.current) {
      setFlash(true)
      const frame = requestAnimationFrame(() => setFlash(false))
      return () => cancelAnimationFrame(frame)
    } else {
      isFirstRender.current = false
      return undefined
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
  return flash
}
